import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage, faMicrophone, faPlus, faVideo } from '@fortawesome/pro-regular-svg-icons'
import { marketUrl } from '~/constants/market'
import { TrophyDetailComponentDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import styles from './TrophyMemoriesEmptyState.module.scss'

interface Props {
  trophy: TrophyDetailComponentDto
}

export const TrophyMemoriesEmptyState: React.FC<Props> = ({ trophy }) => {
  const { t } = useTranslation('trophy_memories')
  const marketLink = trophy.collection && trophy.tokenId
    ? `${marketUrl}/series/${trophy.collection.seriesId}/${trophy.collection.contractAddress}/${trophy.tokenId}`
    : marketUrl

  return (
    <div>
      <p className={ styles.trophyMemoryEmptyState__howto }>
        <Trans
          i18nKey={ t('memory_list_description_1') }
          components={ [
            <strong key="strong-desc1-museum"/>,
          ] }
        />
      </p>

      <p className={ styles.trophyMemoryEmptyState__howto }>
        <Trans
          i18nKey={ t('memory_list_description_2') }
          components={ [
            <a
              key="link-museum"
              className={ styles.trophyMemoryEmptyState__howto__link }
              href=""
            />,
            <strong key="strong-desc2-museum"/>,
            <a
              key="market"
              className={ styles.trophyMemoryEmptyState__howto__link }
              href={ marketLink }
              target="_blank"
              rel="noreferrer"
            />,
            <strong key="strong-desc2-market"/>,
          ] }
        />
      </p>

      <section className={ styles.trophyMemoryEmptyState__container }>
        <h1 className={ styles.trophyMemoryEmptyState__title }>
          { t('empty_state_title') }
        </h1>

        <p className={ styles.trophyMemoryEmptyState__description }>
          <span>
            { t('empty_state_description') }
          </span>
          <br/>
          <span className={ styles.trophyMemoryEmptyState__highlightedDescription }>
            { t('empty_state_highlighted_description') }
          </span>
        </p>

        <Link
          href={ `/trophies/${trophy.id}/memories` }
          className={ styles.trophyMemoryEmptyState__addButton }
          passHref
        >
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__addIcon }
            icon={ faPlus }
          />
          { t('empty_state_add_button') }
        </Link>

        <div>
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faVideo }
          />
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faImage }
          />
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faMicrophone }
          />
        </div>
      </section>
    </div>
  )
}
